export default "/assets/images/dark-moss.312253656ba037e5.jpg";